import styled, { keyframes } from "styled-components";

interface SkeletonWrapperProps {
  $width: string;
  $height: string;
  $borderRadius: string;
}

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const SkeletonWrapper = styled.span<SkeletonWrapperProps>`
  display: inline-block;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  background-color: ${({ theme }) => theme.skeletonBg};
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
